var Block_Args_With_Picto = {

    array_swiper:[],

    init:function(){
        $(window).resize(function(){
            Block_Args_With_Picto.resize();
        });
        Block_Args_With_Picto.resize();
    },
    resize:function(){
        $(".block-args-with-picto").each(function(){
            var _slides_to_show = 0;
            var _id = $(this).attr("id");
            var el = document.getElementById(_id);
            _slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));

            if(_slides_to_show != 0){
                Block_Args_With_Picto.createSwiper(_id, _slides_to_show);
            }else{
                Block_Args_With_Picto.destroySwiper(_id);
            }
        })
    },
    createSwiper:function(pID, _slides_to_show){

        if(!$("#" + pID + " .slider-container").hasClass("swiper-initialized")){
            var swiper = new Swiper(
                "#" + pID + " .slider-container",
                {
                    speed: 600,
                    loop: false,
                    slidesPerView: "auto",
                    centeredSlides: false,
                    freeMode: false,
                    grabCursor: true,
                    mousewheel: false,
                    slideToClickedSlide: false,
                    touchStartPreventDefault: false,
                    preventClicks: true,
                    spaceBetween:60,
                }
            );

            Block_Args_With_Picto.array_swiper.push({id:pID, swiper:swiper, nb_slides:_slides_to_show});
        }
    },
    destroySwiper:function(pID){
        if($("#" + pID + " .slider-container").hasClass("swiper-initialized")){
            for (var i = 0; i < Block_Args_With_Picto.array_swiper.length; i++){
                if(Block_Args_With_Picto.array_swiper[i].id == pID){
                    Block_Args_With_Picto.array_swiper[i].swiper.destroy();
                    Block_Args_With_Picto.array_swiper.splice(i, 1);
                }
            }
        }

    }
}

$(window).load(function(){
    if($(".block-args-with-picto").length){
        Block_Args_With_Picto.init();
    }
})